<template>
    <div class="container">
      <a-modal v-model:visible="visible" :closeIcon="undefined"  :onCancel="false" :maskClosable="false" type="line" title="批量开班">
        <template slot="footer">
      <a-button @click="handleConfirm" :disabled="current/total ===1? false : true" type="primary" >确定</a-button>
    </template>
    <div class="tip">
      {{competele === false? '批量开班进行中，正在创建班级课节，请稍等' :  '进度完成'}}
    </div>
        <div class="baseinfo">
        <a-progress :percent="current/total * 100" class="baseProgess"/> <span>{{current}}/{{total}}</span> 
      </div>

      <div id="tip-communication" ref="information">
        <div class="record" v-for="(item,index) in message">
            {{ item }}
        </div>
      </div>
      </a-modal>
    </div>
  </template>
  <script>
  import classSet from "../../../api/classSet"
  import { defineComponent } from 'vue';
  export default {
    name: 'ProgressTip',
    props:['originalClass'],
    data() {
      return {
        visible: false,
        uuid: '',
        current: undefined,
        total: undefined,
        timer: null,
        message:[],
        competele:false
      }
    },
    // watch(){
    //   let 
    // },
    mounted(){
      this.to_footer()
    },

    methods:{
        init(id) {
        this.visible = true
        this.classId = id
        this.uuid = id.uuid
        if(this.uuid){
          this.start()
        }
        this.to_footer()
      },
      to_footer() {
        this.$nextTick(()=>{
          if(this.$refs.information){
          this.$refs.information? this.$refs.information.scrollTop = '146' : ''
        }
        })
        // div.scrollTop = '150';
      },
      handleConfirm(){
        if((this.current/this.total) == 1){
          this.current = undefined,
          this.total = undefined
          this.timer = null,
          this.message = [],
          this.competelecomp = false,
          this.uuid = '',
          this.visible = false
          let flag = 100
          this.$emit('closeMain', flag)
        }
      },
      start(){
        this.timer = setInterval(()=>{
            this.batchOpenProgress()
            if((this.current/this.total) == 1){
              this.over()
            }
          },500)
      },
      over(){
        clearInterval(this.timer);
        this.uuid = '';
        this.competele = true
      },
      // 批量开班进度条
      batchOpenProgress(item){
      let _this = this;
          classSet
        .batchProgressClass({uuid:_this.uuid})
        .then((res) => {
          // window.open(res.data.targetUrl)
          // window.location.href = res.data.targetUrl
          _this.current = res.data.current
          _this.total = res.data.total
          _this.message = res.data.message;
          console.log(res,'res删除是什么内容')
        })
    },
    }
  }
  
  </script>
  <style lang="scss" scoped>
::v-deep .ant-modal-close-icon{
    display: none;
}
::v-deep .ant-modal-header{
    border: none;
}
::v-deep .ant-modal-footer{
    border: none;
}

::v-deep .ant-progress-text{
  display: none;
}
.tip{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
}

.baseinfo{
  display: flex;
  align-items: center;
  justify-content: center;
}

#tip-communication{
  height: 150px;
  overflow-y: auto;
  margin-top: 20px;
  border: 2px solid rgb(219,220,221);
  padding: 12px;
  box-sizing: border-box;
}
</style>